export default __webpack_public_path__ + "static/media/hon_weng_chong.a9ea4b83.jpg";